import { c as _c } from "react/compiler-runtime";
import { EventListFiltersProps, EventListQueryParams } from '../../typings/EventList.interface';
import { RequestListFiltersProps, RequestListQueryParams } from '../../typings/RequestList.interface';
import useSearchQuery from './useSearchQuery';
import { relative_date_presets, relative_dates } from '../../utils/date';
import { APISubscription } from '../../../../../typings/Subscription.interface';
export const useNextRelativeDate = (filters, subscription) => {
  const $ = _c(8);
  const {
    updateSearchQuery
  } = useSearchQuery();
  let t0;
  bb0: {
    if (!filters.date?.relative) {
      t0 = undefined;
      break bb0;
    }
    const current_index = relative_date_presets.findIndex(key => key === filters.date?.relative);
    if (current_index < 0) {
      t0 = undefined;
      break bb0;
    }
    const next_index = current_index + 1;
    if (next_index >= relative_date_presets.length) {
      t0 = undefined;
      break bb0;
    }
    const next_relative_date_key = relative_date_presets[next_index];
    const next_relative_date = relative_dates[next_relative_date_key];
    if (subscription && next_relative_date?.days > subscription.retention_days) {
      t0 = undefined;
      break bb0;
    }
    let t1;
    if ($[0] !== next_relative_date || $[1] !== next_relative_date_key) {
      t1 = {
        key: next_relative_date_key,
        ...next_relative_date
      };
      $[0] = next_relative_date;
      $[1] = next_relative_date_key;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  const next_relative_date_0 = t0;
  let t1;
  if ($[3] !== updateSearchQuery) {
    t1 = date => {
      updateSearchQuery({
        date
      });
    };
    $[3] = updateSearchQuery;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const updateFilters = t1;
  let t2;
  if ($[5] !== next_relative_date_0 || $[6] !== updateFilters) {
    t2 = {
      next_relative_date: next_relative_date_0,
      updateFilters
    };
    $[5] = next_relative_date_0;
    $[6] = updateFilters;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};